<template>
  <h2 class="text-xl lg:text-3xl leading-none font-semibold mb-2 lg:mb-4" :class="textColor">
    {{ title }}
  </h2>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false, default: undefined },
  textColor: { type: String, required: false, default: 'text-app-primary-1-red--torch' },
})
</script>
